export default __webpack_public_path__ + "static/plant_with_leaves-10c62cb15bfe102d1be740417cd4cd62.png";